export default (value: unknown): value is null | undefined => value == null;